import * as types from './mutation-types'

export default {
    [types.SET_OFFLINE_REVIEWS_COUNT](state, count) {
        state.offlineReviewsCount = count
    },
}
